import React, { Component } from "react";
import { PrismicConfig } from "../../config";
import {RichText as PrismicRichText} from 'prismic-reactjs';
import _ from 'lodash';
import Slices from "../Slices/Slices";

var md5 = require('md5');

export default class RichText extends Component {
	render() {	
		if(!this.props.content) return;

		const content = [];
		_.forEach(this.props.content, (item) => {
			if (item.type === 'heading2' || item.type === 'heading3') {
        const anchor = {
          name: md5(item.text),
          text: '',
					linkType: 'anchor',
					type: "hyperlink",
					data: {
            target: 'blank',
					},
					spans: []
        }
        content.push(anchor);
      }

			content.push(item);
		})

		return <div className="rich-text">
			{PrismicRichText.render(content, PrismicConfig.linkResolver, PrismicConfig.htmlSerializer)}
			{this.props.slices && <Slices slices={this.props.slices} />}
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/components/RichText/RichText.js